import { ContractTerms, Maybe } from 'src/models';

export interface ContractTermsState extends Record<string, unknown> {
  contractTerms: Maybe<ContractTerms[]>;
}

export const INITIAL_CONTRACT_TERMS_STATE: ContractTermsState = {
  contractTerms: undefined,
};
